import { LANGUAGES } from '@pos/i18n';

/** A language's own name ("Tiếng Việt", "English", "한국어"), so a language added later needs no label (ADR 0071). */
export const languageName = (code: string) =>
  LANGUAGES.find((l) => l.code === code)?.label ?? new Intl.DisplayNames([code], { type: 'language' }).of(code) ?? code;
